<template lang = "html">
  <div>
  <b-container class="p-0">
    <b-row class = "w-100 todo-item text-center m-0" :class = "{'is-complete':todo.completed}">
      <b-col class = "done" md = "auto">
        <b-button
          :class = "{'is-complete-but':todo.completed}"
          @click="markComplete"
          variant = "success"
          size = "sm"
          pill
        >
            ✔
        </b-button>
      </b-col>
      <b-col class = "font-weight-bold" v-b-modal.modal-5 @click="$emit('select_task', todo)">
        {{todo.title}}
      </b-col>
      <b-col
        md = "auto"
        :style = "Get_color"
        class = "p-1 rounded align-middle"
        :class = "{'is-complete-but':todo.completed}"
        >
          {{ todo.priotited }}
      </b-col>
      <b-col md="2" class="p-2">
        {{ todo.deadline }}
      </b-col>
      <b-col md = "auto">
        <b-button
          @click="$emit('del-task-app', todo.id)"
          class = "font-weight-bold"
          :class = "{'is-complete-but':todo.completed}"
          variant = "danger"
          size = "sm"
          pill
          :disabled="todo.completed"
          >
            x
        </b-button>
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>

<script>

export default {
  name:"Todo_item",
  props: ["todo"],
  data(){
    return {
      done: false,
    }
  },
  methods: {
    markComplete() {
      this.todo.completed = !this.todo.completed
    },
  },
  computed: {
    Get_color: function(){
      let red=0,green=0,blue=0,max=5,
      level=(this.todo.priotited / max * 100);

      if (level >=50){
        red =255 -Math.round( (level - 50) / 50 * 255);
        green =255;
      }
      else if (level == 0){
          red=230;
          green=230;
          blue=230;
      }
      else {
        red=255;
        green=Math.round(level / 50 * 255);
      }
      return {
        "background-color": "rgb(" + red + "," + green + ", " + blue + ")"
      }
    }
  }
}
</script>

<style lang="css" scoped>
div{
  display: flex;
}

.done{
  color: lightgreen;
}

.done:hover{
  color:green;
}

.text{
  width: 100%;
}

.is-complete{
  background: #5d6d7e !important;
  text-decoration: line-through;
}
.is-complete-but{
  background:  #283747 !important;
  border: 0;
}
</style>
